import { Csr } from "./csr";

export class Usuario {
    id: number;
    organizacaoId: number;
    nome: string;
    email: string;
    senha: string;
    tokenOTP: string;
    changePassword: string;
    token: string;
    csr: Csr;
    dataCadastro: String;
    urlAcesso: String;
    urlProxy: string;
    termoAceitado: boolean;
    status: string;
    pin: string = '';
    pinTemporario = false;
    cpf: string;
    descricaoPerfilAcesso: string;
    idUsuarioAlteracao: number;
    emailUsuarioAlteracao: string;
    ativar: boolean;  
}